import { render, staticRenderFns } from "./SpellList.vue?vue&type=template&id=417ff43e&scoped=true&"
import script from "./SpellList.vue?vue&type=script&lang=js&"
export * from "./SpellList.vue?vue&type=script&lang=js&"
import style0 from "./SpellList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SpellList.vue?vue&type=style&index=1&id=417ff43e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ff43e",
  null
  
)

export default component.exports